<!-- https://primetek.hashnode.dev/vue3-paginator -->

<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-10">
                <label class="p-mr-2">{{ $t("organize_response") }}</label>
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="organize_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedOrganizeData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="organize_name"
                  :header="$t('id_operating_name')"
                  :sortable="true"
                  headerStyle="width: 30rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')"  headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            organizeDelete = dataTable.data;
                            alertDisplay(organizeDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
            <hr />
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("ib_building_location") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
               
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')"   headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col-12 p-lg-6 p-col p-mt-2">
            <div class="p-formgrid p-col p-grid">
              <div class="p-field p-col-11 p-lg-11">
                <label>{{ $t("ib_building_type") }}</label>
                <MultiSelect
                  v-model="buildingTypeSelected"
                  :options="buildingTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div>{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-1 p-lg-1 p-mt-5">
                <Button
                  @click="buildingTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_type == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-col p-mt-2 p-mb-3">
              <div class="p-field p-col-11">
                <label>{{ $t("ib_business_type") }}</label>
                <MultiSelect
                  v-model="businessTypeSelected"
                  :options="businessTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div>{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-1 p-mt-5">
                <Button
                  @click="businessTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_business == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-col p-mt-3">
              <div class="p-col-12">
                <label>{{ $t("ib_building_location_floor") }}</label>
                <div class="p-formgrid p-grid p-col p-mt-3">
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_1"
                      name="check_1"
                      value="1"
                      v-model="checked"
                    />
                    <label>{{ $t("ch_1") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_2"
                      name="check_2"
                      value="2"
                      v-model="checked"
                    />
                    <label>{{ $t("ch_2") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_3"
                      name="check_3"
                      value="3"
                      v-model="checked"
                    />
                    <label>{{ $t("ch_3") }}</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_4"
                      name="check_4"
                      value="4"
                      v-model="checked"
                    />
                    <label>{{ $t("ch_4") }}</label>
                  </div>
                  <div class="p-field-checkbox">
                    <Checkbox
                      id="check_5"
                      name="check_5"
                      value="5"
                      v-model="checked"
                    />
                    <label>{{ $t("ch_5") }}</label>
                  </div>
                </div>
              </div>

              <div class="p-col">
                <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                  <div class="p-field p-col p-mt-2">
                    <!-- <Button
                      @click="exportCSV()"
                      :label="$t('exportBtn')"
                      class="p-button-info p-mr-3"
                      style="background-color: green"
                    /> -->
                    <Button
                      @click="clearSearchField()"
                      :label="$t('clearBtn')"
                      class="p-button-clear p-mr-3"
                    />
                    <Button
                      @click="search()
                      cou = true"
                      :label="$t('searchBtn')"
                      class="p-button-info p-mr-2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <!-- :contentStyle="{ 'overflow-y': 'scroll' }" -->
    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
     
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ResponseAreaModalHeader')"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
      scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        ref="dt"
        :rowHover="true"
        :exportFilename = "`สรุปจำนวนอาคาร/สื่งปลูกสร้าง-${date}`"
        :filters="filters"
        :sortOrder="1"
        sortField="index"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
      <!-- Doe : เพิ่ม ลำดับ 1/4  จบ sortField="index" :sortOrder="1" -->
      <template #header>
          <div class="p-grid p-col ">
            
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

             <!-- Doe PDF เลือกได้  1/5   -->
             <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
      
        <!-- <template #header>
          <div class="table-header p-col-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
        <template #empty>{{ $t("TableEmpty") }}</template>
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->

        <div v-if="columns_P_all == true">
          <Column
            field="P_all"
            :header="$t('ib_building_location')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              
              <div v-if="dataTable.data.P_all === 'รวม'">
                รวม
              </div>
              <div v-else-if="dataTable.data.tambon_name != null">
                {{ dataTable.data.province_name }},
                {{ dataTable.data.amphur_name }}, {{ dataTable.data.tambon_name }}
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_floor == true">
          <Column 
            field="floor"
            :header="$t('ib_building_location_floor')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div v-if="Number(dataTable.data.floor) == 0" class="table_row">{{ $t("ch_1") }}</div>
              <div
                v-else-if="'-'" class="table_row"
              >
               -
              </div>
              <div
                v-else-if="
                  Number(dataTable.data.floor) >= 1 &&
                  Number(dataTable.data.floor) <= 4
                " class="table_row"
              >
                {{ $t("ch_2") }}
              </div>
              <div
                v-else-if="
                  Number(dataTable.data.floor) >= 5 &&
                  Number(dataTable.data.floor) <= 7
                " class="table_row"
              >
                {{ $t("ch_3") }}
              </div>
              <div
                v-else-if="
                  Number(dataTable.data.floor) >= 8 &&
                  Number(dataTable.data.floor) <= 20
                " class="table_row"
              >
                {{ $t("ch_4") }}
              </div>
              <div v-else-if="Number(dataTable.data.floor) > 20" class="table_row">
                {{ $t("ch_5") }}
              </div>
              <!-- {{ dataTable.data.floor }} -->
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_type == true">  
          <Column field="type" :header="$t('ib_building_type')" :sortable="true"   :headerStyle="{width: '15rem',textAlign:'center'}">
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.type }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else> 
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_business == true">
          <Column
            field="business"
            :header="$t('ib_business_type')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.business }} 
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else> 
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_organize_name == true">
        <Column
          field="organize_name"
          :header="$t('organize_response')"
          :sortable="true"
          headerStyle="width: 15rem"
        >
          <template #body="dataTable">
            {{ dataTable.data.organize_name }}
          </template>
        </Column>
      </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_amount == true">
        <Column field="amount" :header="$t('amount_building')" :sortable="true"  :headerStyle="{width: '15rem',textAlign:'center'}">
          <template #body="dataTable">
            <div class="table_row">
              {{ dataTable.data.amount }}
            </div>
            
          </template>
        </Column>
      </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
      </DataTable>
      <!-- <Paginator
        :first="offset"
        :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]"
        :totalRecords="totalItemsCount"
        @page="onPage($event)"
      >
        <template #left="slotProps">
          แสดงผล: {{ slotProps.state.first + 1 }} ถึง:
          {{ slotProps.state.first + slotProps.state.rows }} แสดงข้อมูลทีละ:
          {{ slotProps.state.rows }}
        </template>
      </Paginator> -->
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
import organizeTable from "../OrganizeMultiSelectTable";
import responseAreaTable from "../ResponseAreaTable";
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-building-amount",
  components: {
    organizeTable,
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      table: [],
      filters: {},
      displayConfirmation: false,
      showOrganize: false,
      showResponseArea: false,
      offset: 0,
      totalItemsCount: 0,

      buildingTypeOptions: [],
      buildingTypeSelected: null,

      businessTypeOptions: [],
      businessTypeSelected: null,

      selectedOrganizeData: null,
      organize_table: [],

      selectedResponseAreaData: null,
      responseArea_table: [],

      organizeDelete: null,
      responseAreaDelete: null,

      checked: [],
      error_business: false,
      error_type: false,
      loading: false,

      parentmessage_organize: null,
      parentmessage_area: null,

      
      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางสรุปจำนวนอาคาร/สิ่งปลูกสร้าง",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:15,
      PDF_FontBodyVer:12,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                          index: {cellWidth: 35},

      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                        index: {cellWidth: 35}, 
      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "ที่ตั้งอาคาร", dataKey: "P_all"},
                  {title: "จำนวนชั้น", dataKey: "floor" },
                  {title: "ประเภทอาคาร", dataKey: "type"},
                  {title: "ประเภทกิจการ", dataKey: "business"},
                  {title: "หน่วยงานรับผิดชอบ", dataKey: "organize_name"},
                  {title: "จำนวน(อาคาร)", dataKey: "amount"},

              ],
      columnsSelector:null,
      columnsSelectorDialog:null,
      column_PDF:[],
      head_PDF:[],
      
      displayEditPDF:false,

      columns_index:true,
      columns_P_all:true,
      columns_floor:true,
      columns_type:true,
      columns_business:true,

      columns_organize_name:true,
      columns_amount:true,
     
      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"หน่วยงานรับผิดชอบ",
          textShow:"",
        },
        {
          DataName:"ที่ตั้งอาคาร",
          textShow:"",
        },
        {
          DataName:"ประเภทอาคาร",
          textShow:"",
        },
        {
          DataName:"ประเภทกิจการ",
          textShow:"",
        },
        {
          DataName:"จำนวนชั้น",
          textShow:"",
        },
      ],

      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});
 
                let columns = this.columnsSelector
                const Body_setCenter = ["index","amount","type","business","floor"]
                
                // const PintPDF = {
                //   streak:this.setPDF_Ver,
                //   setPosition:this.setPosition_Ver,
                //   PDF_Styles:this.setPDF_Styles,
                //   // data:this.$refs.dt.processedData,
                //   columns:columns,
                //   columnsStyles:this.PDF_BodySizeSelect,
                //   FileName:this.setnamePDF,

                //   checkBody_rowSpan:true,
                //   Body_rowSpan:this.Body_rowSpan,

                //   checkBody_Center:true,
                //   Body_Center:Body_setCenter,
                //   Col_FontSize:this.PDF_FontHeaderVer,
                //   Body_FontSize:this.PDF_FontBodyVer,
                //   minCell:this.PDF_minCellWidthVer,
                //   marginPDF:this.setPDF_Margin,
                //   fillColorPDF:this.setPDF_fillColor,
                // }
                const PintPDF = {
                  streak:this.setPDF_Ver,
                  setPosition:this.setPosition_Ver,
                  PDF_Styles:this.setPDF_Styles,
                  // data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeSelect,
                  FileName:this.setnamePDF,

                  checkBody_rowSpan:true,
                  Body_rowSpan:this.Body_rowSpan,

                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderVer,
                  Body_FontSize:this.PDF_FontBodyVer,
                  minCell:this.PDF_minCellWidthVer,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                }
                this.printPDF2(this.head_PDF,
                                 this.column_PDF,
                                 this.$refs.dt.processedData,
                                 PintPDF)  
              }
            }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let columns = this.columnsSelector

                const Body_setCenter = ["index","amount","type","business","floor"]
                
                const PintPDF = {
                  streak:this.setPDF_Hor,
                  setPosition:this.setPosition_Hor,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeHorSelect,
                  FileName:this.setnamePDF,

                  checkBody_rowSpan:true,
                  Body_rowSpan:this.Body_rowSpan,

                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderHor,
                  Body_FontSize:this.PDF_FontBodyHor,
                  minCell:this.PDF_minCellWidthHor,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor
                }
                this.printPDF2(this.head_PDF,
                                 this.column_PDF,
                                 this.$refs.dt.processedData,
                                 PintPDF)   
            }
          }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    filters(val) {
      // debugger;
      console.log(val);
    },
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },

    showResponseArea(val) {
      if (val == true) {
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },

    buildingTypeOptions(val) {
      if (val != null) {
        this.buildingTypeSelected = val;
      }
    },

    businessTypeOptions(val) {
      if (val != null) {
        this.businessTypeSelected = val;
      }
    },

    buildingTypeSelected(val) {
      if (val != null) {
        this.error_type = false;
        if (val.length == 0) {
          this.buildingTypeSelected = null;
        }
      }
    },

    businessTypeSelected(val) {
      if (val != null) {
        this.error_business = false;
        if (val.length == 0) {
          this.businessTypeSelected = null;
        }
      }
    },

    table(val) {
      // console.log(val);
      if (val.length > 0) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },

  },
  async created() {

    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

    this.checked = ["1", "2", "3", "4", "5"];

    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-18" },
      })
      .then((response) => {
        this.buildingTypeOptions = response.data.data;
      });
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-19" },
      })
      .then((response) => {
        this.businessTypeOptions = response.data.data;
      });

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  mounted() {},
  methods: {
    onPage(event) {
      // debugger;
      //event.page: New page number
      //event.first: Index of first record
      //event.rows: Number of rows to display in new page
      //event.pageCount: Total number of pages
      console.log(event);
    },
    exportCSV() {
      if (this.table != "") {
        // debugger;
        this.$refs.dt.exportCSV();
      }
      
    },
    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push(variable[i]);
        }
      }
    },

    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {

          return (this.columns_P_all ? item.P_all.includes(this.filter) : "") ||
                 (this.columns_floor ? item.floor.includes(this.filter) : "") ||
                 (this.columns_type ? item.type.includes(this.filter) : "") ||
                 (this.columns_business ? item.business.includes(this.filter) : "") ||
                 (this.columns_organize_name ? item.organize_name.includes(this.filter) : "") ||
                 (this.columns_amount ? item.amount.includes(this.filter) : "")

      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
 
      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      this.filter='';
      this.cloneTable=[];
      // debugger;
      this.loading = true;
      if (
        this.buildingTypeSelected != null &&
        this.businessTypeSelected != null
      ) {
        // debugger;

        if (this.organize_table.length > 3) {
          this.loading = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "ข้อมูลที่เลือกเยอะเกินไป",
          //   detail: "กรุณาเลือกข้อมูลหน่วยงานไม่เกิน 3 หน่วยงาน",
          //   life: 3000,
          // });
          this.$fire({
              type: "error",
              title:"ข้อมูลที่เลือกเยอะเกินไป",
              text: "กรุณาเลือกข้อมูลหน่วยงานไม่เกิน 3 หน่วยงาน",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });

          return;
        }

        if (this.responseArea_table.length > 3) {
          this.loading = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "ข้อมูลที่เลือกเยอะเกินไป",
          //   detail: "กรุณาเลือกข้อมูลที่ตั้งอาคารไม่เกิน 3 ที่ตั้ง",
          //   life: 3000,
          // });
          this.$fire({
              type: "error",
              title:"ข้อมูลที่เลือกเยอะเกินไป",
              text: "กรุณาเลือกข้อมูลที่ตั้งอาคารไม่เกิน 3 ที่ตั้ง",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });

          return;
        }

        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-building",
              organize: this.organize_table,
              location: this.responseArea_table,
              type: this.buildingTypeSelected,
              business: this.businessTypeSelected,
              floor: this.checked,
            },
          })
          .then((response) => {
            this.table = [];
            this.table = response.data.data;
           
            // Doe ค้นหา  4/6 
            this.cloneTable = response.data.data
            // Doe ค้นหา  4/6 
            // console.log(this.table)
            // Doe : เพิ่ม ลำดับ 3/4
            for (let i = 0; i < this.table.length; i++) { 
              this.table[i]["index"] =i+1;
            }
            // Doe : เพิ่ม ลำดับ 3/4 จบ
            // Doe : รวม จังหวัด
            var data1 = this.table.map(obj => 
              data1= obj.province_name)
              
            var data2 = this.table.map(obj => 
              data2= obj.amphur_name)

            var data3 = this.table.map(obj => 
              data3= obj.tambon_name)

              // console.log('data1 ',data1);
              // console.log('data2 ',data2);
              // console.log('data3 ',data3);
          
            for (let index = 0; index < data1.length; index++) {
              if (data1[index] == null) {
                data1[index] = "-"
              }
              const element = data1[index];

              if (data2[index] == null) {
                data2[index] = "-"
              }
              const element2 = data2[index];
              if (data3[index] == null) {
                data3[index] = "-"
              }
              const element3 = data3[index];

              // const element = data1[index];
              // const element2 = data2[index];
              // const element3 = data3[index];
              // console.log(element)
              // console.log(element2)
              // console.log(element3)
              // console.log(this.table)
              let textAll = ''
                  if (element == "-" && element2 == "-" && element3 == "-" ) {
                    textAll += `-`;
                  }else{
                    textAll += `${element}, ${element2}, ${element3}`;
                  }
  
                this.table[index]["P_all"] = textAll
              }
       
            this.setSearchText_Footer()
            if (this.table.length !== 0) {
              this.format_PDF(this.table)
            }
          });

          if (this.columns_disabled == true) {
            this.table = this.cloneTable
            // console.log(this.table)
          }else{
            this.table = []
          }
          
        this.loading = false;
      } else {
        this.table = [];
        if (this.buildingTypeSelected == null) {
          this.error_type = true;
        }
        if (this.businessTypeSelected == null) {
          this.error_business = true;
        }
        this.loading = false;
      }
    },
    setSearchText_Footer(){
          this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.organize_table.length !== 0 ||
              this.responseArea_table.length !== 0 ||
              this.buildingTypeSelected.length !== 0 ||
              this.businessTypeSelected.length !== 0 ||
              this.checked.length !== 0   ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "หน่วยงานรับผิดชอบ" && this.organize_table.length !== 0){
                  element.textShow = this.setArray_to_Text(this.organize_table,"organize_name")
                }
                if(element.DataName === "ที่ตั้งอาคาร" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "ประเภทอาคาร" && this.buildingTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.buildingTypeSelected,"system_name")
                }
                if(element.DataName === "ประเภทกิจการ" && this.businessTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.businessTypeSelected,"system_name")
                }
                if(element.DataName === "จำนวนชั้น" && this.checked.length !== 0){
                  element.textShow = this.setArray_to_Text(this.checked,null)
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []

      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          if (element === "1") {
            text += "ไม่ระบุ" + ",";
          }else if (element === "2") {
            text += "1-4" + ",";
          }else if (element === "3") {
            text += "5-7" + ",";
          }else if (element === "4") {
            text += "8-20" + ",";
          }else if (element === "5") {
            text += "มากกว่า 20" + ",";
          }
          
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      // console.log(data)
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      if (this.organizeDelete != null) {
        this.organize_table = this.organize_table.filter(
          (val) => val !== this.organizeDelete
        );
      }
      if (this.responseAreaDelete != null) {
        this.responseArea_table = this.responseArea_table.filter(
          (val) => val !== this.responseAreaDelete
        );
      }
      this.displayConfirmation = false;
      this.organizeDelete = null;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.organize_table = [];
      this.responseArea_table = [];
      this.buildingTypeSelected = null;
      this.businessTypeSelected = null;
      this.checked = [];
      this.error_business = false;
      this.error_type = false;
      this.multiSelectClearFilerValue +=1;
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.cloneTable=[];
      this.table = [];
      
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
     // Doe PDF เลือกได้  5/5  
     EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else if(this.columnsSelectorDialog.length <= 6){
        
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        } 

        this.PDF_minCellWidthHor = 90
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else{
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = this.PDF_BodySize

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 10
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_P_all = false
          this.columns_floor = false
          this.columns_type = false
          this.columns_business = false

          this.columns_organize_name = false
          this.columns_amount = false

          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 7){
            
            this.columns_index = true
            this.columns_P_all = true
            this.columns_floor = true
            this.columns_type = true
            this.columns_business = true

            this.columns_organize_name = true
            this.columns_amount = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "P_all") {
                this.columns_P_all = true 
              }else if(!getData.includes("P_all")){
                
                this.columns_P_all = false
              }

              if (element == "floor") {
                this.columns_floor = true 
              }else if(!getData.includes("floor")){
                
                this.columns_floor = false
              }

              if (element == "type") {
                this.columns_type = true 
              }else if(!getData.includes("type")){
                
                this.columns_type = false
              }

              if (element == "business") {
                this.columns_business = true 
              }else if(!getData.includes("business")){
                
                this.columns_business = false
              }

              if (element == "organize_name") {
                this.columns_organize_name = true 
              }else if(!getData.includes("organize_name")){
                
                this.columns_organize_name = false
              }

              if (element == "amount") {
                this.columns_amount = true 
              }else if(!getData.includes("amount")){
                
                this.columns_amount = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

      format_PDF(data_table){
        // console.log(data_table)
        let head_PDF = [
        {title:"ลำดับ",styles:{fillColor: [95,154,250]}},
        {title:"ที่ตั้งอาคาร",styles:{fillColor: [95,154,250]}},
        {title:"จำนวนชั้น",styles:{fillColor: [95,154,250]}},
        {title:"ประเภทอาคาร",styles:{fillColor: [95,154,250]}},
        {title:"ประเภทกิจการ",styles:{fillColor: [95,154,250]}},
        {title:"หน่วยงานรับผิดชอบ",styles:{fillColor: [95,154,250]}},
        {title:"จำนวนอาคาร",styles:{fillColor: [95,154,250]}}
      ]
        let column_PDF = []
        let body_data = []
        let Body_setCenter = []   
        let Body_rowSpan = []
        let sum = 0
        let data_row = []
        if(this.businessTypeSelected !== null){
          
          for(let index = 0; index < data_table.length; index++){
            // const element = data_table[index];
            // const element_floor = element.floor
     
            // if(element !== null){
            //     data_row.push({
            //       P_all: element.P_all,
            //       floor: this.setArray_to_Text((+element_floor).toLocaleString(), null),
            //       type: element.type,
            //       business: element.business,
            //       organize_name: element.organize_name,
            //       amount: element.amount
            //     })
            // }
          }
          column_PDF.push({dataKey:"index"})
         column_PDF.push({dataKey:"P_all"})
         column_PDF.push({dataKey:"floor"})
         column_PDF.push({dataKey:"type"})
         column_PDF.push({dataKey:"business"})
         column_PDF.push({dataKey:"organize_name"})
         column_PDF.push({dataKey:"amount"})

         
         for (let index = 0; index < data_table.length; index++) {
            const element = data_table[index];
                body_data.push(element)
                // console.log(element)
                sum += parseFloat(element.amount)
          }
          body_data.push({
            P_all:"รวม", 
            amount: sum,
            amphur_name: '-',
            business: '-',
            floor: '-',
            organize_id: '-',
            organize_name: '-',
            province_name: '-',
            tambon_name: '-',
            type: '-'
          })
          
          column_PDF.forEach(element => {
            if (!element.dataKey.includes("P_all")) {
              Body_setCenter.push(element.dataKey)
            }
          });
          for (let i = 0; i <  body_data.length; i++) { 
            body_data[i]["index"] =i+1;
          }

          for(let index=0; index < body_data.length; index++){
            const element  = body_data[index]
            data_row.push({
                  P_all: element.P_all,
                  floor: this.setArray_to_Text((+element.amount).toLocaleString(), null),
                  type: element.type,
                  business: element.business,
                  organize_name: element.organize_name,
                  amount: element.amount,
                  index: element.index
            })
          }
          // console.log(body_data)
          // console.log(data_row)
          
          
          Body_rowSpan = []
          for (let index = 0; index < data_row.length; index++) {
            const element = data_row[index];
            // console.log(element)
            Body_rowSpan.push({dataKey:"P_all",raw:element,
                              status:"rowSpan",num:"5",
                              halign:"center",valign:"middle"})
          }
        }
        this.head_PDF = head_PDF
        this.column_PDF = column_PDF

        this.body_dataPDF = body_data
        this.cloneTable = this.setCloneData(body_data)
        // console.log(this.cloneTable)
        this.Body_rowSpan = Body_rowSpan
        this.Body_setCenterPDF = Body_setCenter
      }

      // format_PDF(data_table){
      //   console.log(data_table)
 
      //   let body_data = []

      //   let Body_rowSpan = []
      //   let sum = 0
  
      //   if(this.businessTypeSelected !== null){
      //    for (let index = 0; index < data_table.length; index++) {
      //       const element = data_table[index];
      //           sum += parseFloat(element.amount)
      //     }
      //     data_table.push({
      //       P_all:"รวม", 
      //       amount: sum,
      //       amphur_name: '-',
      //       business: '-',
      //       floor: '-',
      //       organize_id: '-',
      //       organize_name: '-',
      //       province_name: '-',
      //       tambon_name: '-',
      //       type: '-'
      //     })
      //     for (let i = 0; i <  data_table.length; i++) { 
      //       data_table[i]["index"] =i+1;
      //     }
          
      //     // console.log(body_data)
      //     Body_rowSpan = []
      //     for (let index = 0; index < body_data.length; index++) {
      //       const element = body_data[index];
      //       // console.log(element)
      //       Body_rowSpan.push({dataKey:"P_all",raw:element,
      //                         status:"rowSpan",num:"5",
      //                         halign:"center",valign:"middle"})
      //     }
      //   }
      //   // this.head_PDF = head_PDF
      //   // this.column_PDF = column_PDF

      //   // this.body_dataPDF = body_data
      //   this.cloneTable = this.setCloneData(data_table)
      //   // console.log(this.cloneTable)
      //   // this.Body_rowSpan = Body_rowSpan
      //   // this.Body_setCenterPDF = Body_setCenter
      // }
  },
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
.p-multiselect {
  min-width: 12rem;
}

.multiselect-custom {
  // Doe PDF เลือกได้
  width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
